module.exports = __webpack_public_path__ + "img/图片11.0c09b284.png";